import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

interface AdminUser {
  id: number;
  full_name: string;
  email: string;
  contact_no: string;
  role: 'super_admin' | 'admin' | 'operation';
  status: number;
  createddt: string;
  updateddt: string | null;
}

interface ListAdminUsersRequest {
  role?: string;
}

interface ListAdminUsersResponse {
  error: boolean;
  message: string;
  data: AdminUser[];
}

interface UpdateAdminUserRequest {
  id: number;
  full_name: string;
  email: string;
  contact_no: string;
  role: string;
  status: number;
  password?: string;
}

interface UpdateAdminUserResponse {
  error: boolean;
  message: string;
  data?: AdminUser;
}

export const adminUserListApi = createApi({
  reducerPath: 'adminUserListApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set(
        'authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3'
      );
      headers.set('Content-Type', 'application/x-www-form-urlencoded');
      return headers;
    },
  }),
  tagTypes: ['AdminUser'],
  endpoints: (build) => ({
    listAdminUsers: build.query<ListAdminUsersResponse, ListAdminUsersRequest>({
      query: (params) => {
        const formData = new URLSearchParams();
        
        // Only add role if it's provided and not empty
        if (params.role && params.role.trim() !== '') {
          formData.append('role', params.role);
        } 
        
        console.log('API Request - Role:', params.role);
        console.log('FormData:', formData.toString());
        
        return {
          url: 'admin/adminlistusers',
          method: 'POST',
          body: formData.toString(),
        };
      },
      providesTags: ['AdminUser'],
      transformResponse: (response: any) => {
        console.log('API Raw Response:', response);
        return response;
      },
    }),
    
    updateAdminUser: build.mutation<UpdateAdminUserResponse, UpdateAdminUserRequest>({
      query: (userData) => {
        const formData = new URLSearchParams();
        formData.append('id', userData.id.toString());
        formData.append('full_name', userData.full_name);
        formData.append('email', userData.email);
        formData.append('contact_no', userData.contact_no);
        formData.append('role', userData.role);
        formData.append('status', userData.status.toString());
        
        // Only add password if it's provided
        if (userData.password && userData.password.trim() !== '') {
          formData.append('password', userData.password);
        }
        
        console.log('Update API Request:', formData.toString());
        
        return {
          url: 'admin/update-adminuser',
          method: 'POST',
          body: formData.toString(),
        };
      },
      invalidatesTags: ['AdminUser'],
      transformResponse: (response: any) => {
        console.log('Update API Response:', response);
        return response;
      },
    }),
  }),
});

export const {
  useListAdminUsersQuery,
  useUpdateAdminUserMutation,
} = adminUserListApi;